#import "../../../../graphql/fragments/sms-membership-stats-fragment.graphql"
#import "../../../../graphql/fragments/email-membership-stats-fragment.graphql"

# This stub is just for the list of audiences so we don't fetch tons of data on
# each audience that we don't need

fragment AudienceStub on Audience {
    id
    name
    description
    htmlUrl
    htmlUrlPath
    htmlUrlPathForList
    membershipStats {
        ...EmailMembershipStatsFragment
    }
    smsMembershipStats {
        ...SmsMembershipStatsFragment
    }
    publishedEditions(first: 1) {
        edges {
            node {
                id
                name
                scheduledTime
                sendTime
                campaign {
                    id
                    name
                }
            }
        }
    }
    isWebFX
    isSyncing
    isPublic
    modifiedTime
    deletedTime
    lastContactedTime
    isArchived
}
